'use strict';

// calcul top green - orange -red bars if existing
function calculTopBars () {
  var wooGreenBar = $('#green-bar-counter');
  var wooOrangeBar = $('#orange-bar-counter');
  var wooRedBar = $('#red-bar-counter');
  var greenCounter = $('.criterium.result-1').length;
  var orangeCounter = $('.criterium.result-2').length;
  var redCounter = $('.criterium.result-3').length;
  var totalCounter = greenCounter + orangeCounter + redCounter;

  wooGreenBar.find('.count').text(greenCounter);
  wooOrangeBar.find('.count').text(orangeCounter);
  wooRedBar.find('.count').text(redCounter);

  if (totalCounter > 0) {
    updateProgressStyle(wooGreenBar, greenCounter, totalCounter);
    updateProgressStyle(wooOrangeBar, orangeCounter, totalCounter);
    updateProgressStyle(wooRedBar, redCounter, totalCounter);
  } else {
    $('#dashboard-bars .progress-bar').css('width', '0%');
    $('#dashboard-bars .progress-bar').css('border', 'none');
  }
}

function updateProgressStyle (el, current, total) {
  if (el && current && total) {
    if (current > 0) {
      el.find('.progress-bar').stop().animate({
        width: (100 / total * current) + '%'
      }, 500);
    } else {
      el.find('.progress-bar').css('width', '0%');
      el.find('.progress-bar').css('border', 'none');
    }
  }
}

module.exports = calculTopBars;
